// @ts-nocheck
import { Checkbox } from "antd";
import BaseComponent from "../../../../base/common/BaseComponent";
import EllipsisToolTip from "../../../../base/basicComponents/ellipsisToolTip";
import { ExpendTextAreaByProps } from "../../../../base/basicComponents/input/index";
import Buttons from "../../../../base/basicComponents/button";
import NormalSelect from "../../../../base/basicComponents/select";
import { SectionStatusDiv } from "../../../../base/basicComponents/status";
import UploadFile from "../../../../base/basicComponents/uploadFile";
import { fileTags, flowBusinessIdMap } from "../../../publicDictionaryValues";
import "../index.scss";
import HistoricalVersionComponent from "../../../../base/basicComponents/historicalVersionComponent";
import ViewNoteHyperLinkModal from "../../../../base/basicComponents/viewNoteHyperLinkModal";
import { PreviewFileLink } from "app/pages/previewFile";
class BaseTbody extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      inputRef: "",
    };
    // @ts-ignore
    this.isHideReplaceBtn = false;
    // @ts-ignore
    this.isHideDeleteBtn = false;
    // @ts-ignore
    this.isHideApproveBtn = false;
    // @ts-ignore
    this.isHideReturnBtn = false;
  }
  returnCheckBox = (column: any, row: any, hasSubmit: any, fileSectionDisabled: any) => {
    const lineId = row.data.find((item: any) => item.name === "lineId").value;
    return (
      <td key={lineId} className="checkboxtd">
        <Checkbox
          checked={
            column.check(row.data.find((x: any) => x.name === "lineId").value) ? true : false
          }
          onChange={(e) =>
            column.onCheck(row.data.find((x: any) => x.name === "lineId").value, e.target)
          }
          disabled={hasSubmit || fileSectionDisabled}
        />
      </td>
    );
  };

  returnLink = (rowColumn: any, isSupportingFile: any) => {
    return (
      <div className="linkContainer">
        <PreviewFileLink fileName={rowColumn.value} fileId={rowColumn.fileId} className="linkName">
          <EllipsisToolTip children={rowColumn.value} title={rowColumn.value} placement="top" />
        </PreviewFileLink>
      </div>
    );
  };

  returnFileName = (rowColumn: any, column: any, row: any) => {
    const fileId = row.data.find((item: any) => item.name === "fileId").value;
    const fileKey = row.data.find((item: any) => item.name === "fileKey").value.trim();
    return (
      <div className="fileNameContainer">
        <EllipsisToolTip
          children={
            <PreviewFileLink fileId={fileId} fileName={rowColumn.value}>
              {rowColumn.value}
            </PreviewFileLink>
          }
          title={rowColumn.value}
          placement="top"
        />
        {this.props.isShowHistoryVersion && (
          // @ts-ignore
          <HistoricalVersionComponent
            fileId={fileId}
            fileKey={fileKey}
            flowBusinessId={flowBusinessIdMap.procedureFile}
          />
        )}
      </div>
    );
  };

  returnInput = (
    rowColumn: any,
    column: any,
    rowIndex: any,
    procedureNoteMaxLength: any,
    fileSectionDisabled: any
  ) => {
    const fieldDisabled = fileSectionDisabled || column.isDisabled;
    return (
      <>
        {rowColumn.name === "note" && fieldDisabled ? (
          <ViewNoteHyperLinkModal value={rowColumn.value} />
        ) : (
          <ExpendTextAreaByProps
            value={rowColumn.value}
            onChange={(ele: any) => this.props.inputOnChange(ele.target)}
            maxLength={procedureNoteMaxLength}
            disabled={fieldDisabled}
            dataname={column.dataName}
            rowindex={rowIndex}
            style={{
              display: column.isShow ? "table-cell" : "none",
            }}
            ref={column.ref}
            readOnly={rowColumn.readOnly}
            handleTableChange={this.props.handleChangeTableHeight}
            isExpendData={this.props.isExpendData}
            setIsExpendNote={this.props.setIsExpendNote}
            isScrollExpend
            className="noteInputStyle"
            testid={`note-${rowIndex}`}
          />
        )}
      </>
    );
  };

  returnSelect = (rowColumn: any, column: any, row: any, rowIndex: any) => {
    return (
      <>
        <NormalSelect
          optionList={rowColumn.optionList}
          disabled={rowColumn.isDisabled || column.isDisabled || row.isReturned}
          value={rowColumn.value}
          handleChange={(e: any) =>
            column.onChange(row.data.find((x: any) => x.name === "lineId").value, e)
          }
          getPopupContainer="null"
          testid={`${column.dataName}-${rowIndex}`}
        />
      </>
    );
  };

  returnButton = (row: any, column: any, rowIndex: any, isSupportingFile: any, status: any) => {
    const fileNameData = row.data.find((item: any) => item.name === "fileName");
    const tagValue = fileNameData && fileNameData.tagValue;

    return (
      <div className="buttonTd-content">
        {/* @ts-ignore */}
        {!this.isHideReplaceBtn && !(tagValue === fileTags.deleted && status.value === null) && (
          <>
            <Buttons
              color={column.approveColor}
              size="small"
              onClick={(e: any) => column.onApproveClick(e)}
              disabled={row.isApproveDisabled}
              rowindex={rowIndex}
              testid={`replace-btn-${rowIndex}`}
            >
              {column.approveText}
            </Buttons>
            <UploadFile
              fileInputRef={row.replaceRef}
              isMultiple={false}
              handleFileSelect={this.props.handleFileSelect}
              rowindex={rowIndex}
              isSupportingFile={isSupportingFile}
              testid={`upload-${rowIndex}`}
            />
          </>
        )}
        {/* @ts-ignore */}
        {!this.isHideDeleteBtn && !(tagValue === fileTags.deleted && status.value === null) && (
          <Buttons
            color={column.returnColor}
            size="small"
            onClick={column.onReturnClick(rowIndex)}
            disabled={row.isReturnDisabled || tagValue === fileTags.deleted}
            rowindex={rowIndex}
            testid={`delete-btn-${rowIndex}`}
          >
            {column.returnText}
          </Buttons>
        )}
      </div>
    );
  };

  returnTag = (column: any, rowColumn: any, tagValue: any) => {
    return (
      column.dataName === "status" && (
        <>
          <SectionStatusDiv status={rowColumn.value} tagValue={tagValue} />
        </>
      )
    );
  };

  judgeIsShowText = (column: any) => {
    return (
      column.type !== "link" &&
      column.type !== "input" &&
      column.type !== "select" &&
      column.type !== "tag" &&
      column.type !== "button" &&
      column.type !== "fileName"
    );
  };

  returnTrErrorClass = (row: any) => (row.isError ? "red" : "normal");

  columnShowStyle = (column: any) => (column.isShow ? "table-cell" : "none");

  render() {
    const {
      data,
      columns,
      procedureNoteMaxLength,
      fileSectionDisabled,
      hasSubmit,
      isSupportingFile,
    } = this.props;

    const typeToClassName = {
      link: "linkTd",
      input: "inputTd",
      default: "textTd",
      tag: "tagTd",
      select: "selectTd",
      button: "buttonTd",
      fileName: "fileNameTd",
    };

    return (
      <>
        <tbody>
          {data.map((row: any, rowIndex: any) => {
            const status = row.data.find((item: any) => item.name === "status");
            return (
              <tr
                key={row.data.find((item: any) => item.name === "lineId").value}
                className={`table-tr ${this.returnTrErrorClass(row)}`}
                id={`table-tr-${rowIndex}`}
              >
                {columns.map((column: any, columnIndex: any) => {
                  if (!column.isShow) {
                    return;
                  }
                  const rowColumn = row.data.find((x: any) => x.name === column.dataName);
                  const tagValue = row.data.find((x: any) => x.name === "fileName").tagValue;
                  if (column.type === "checkbox") {
                    return this.returnCheckBox(column, row, hasSubmit, fileSectionDisabled);
                  } else {
                    return (
                      // @ts-ignore
                      <td
                        key={column.dataName}
                        style={{
                          display: this.columnShowStyle(column),
                        }}
                        className={typeToClassName[column.type] || typeToClassName.default}
                      >
                        {column.type === "link" && this.returnLink(rowColumn, isSupportingFile)}
                        {column.type === "fileName" && this.returnFileName(rowColumn, column, row)}
                        {column.type === "input" &&
                          this.returnInput(
                            rowColumn,
                            column,
                            rowIndex,
                            procedureNoteMaxLength,
                            fileSectionDisabled
                          )}
                        {column.type === "select" &&
                          this.returnSelect(rowColumn, column, row, rowIndex)}
                        {column.type === "button" &&
                          this.returnButton(row, column, rowIndex, isSupportingFile, status)}
                        {column.type === "tag" && this.returnTag(column, rowColumn, tagValue)}
                        {this.judgeIsShowText(column) && rowColumn.value}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </>
    );
  }
}

export default BaseTbody;
